import { useState } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { IconButton, AppBar, Box, Toolbar, styled, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import i18next from "i18next";
import NavDrawer from "./NavDrawer";
import TransLang from "./TransLang"
import { useTheme } from '@mui/material/styles';
import { Pages } from "../../../constants";
import DarkModeToggle from "../../global/DarkModeToggle";
// import logo from './../../../assets/Logo/logo.png'
function Navbar2({ data }) {
    const theme = useTheme();
    let lng = i18next.language
    const [drawer, setDrawer] = useState(false);

    const StyledLink = styled(NavLink)(({ theme, isActive }) => ({
        textDecoration: "none",
        fontSize: 16,
        textTransform: 'capitalize',
        color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
        transition: '0.5s',
        fontWeight: 600,
        '&:hover': {
            color: theme.palette.nav.hover,
            textDecoration: 'underline',
        },
    }));
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    return (
        <>
            <AppBar position="static" elevation={0} sx={{
                // backgroundColor: '#041733',
                backgroundColor: theme.palette.nav.main,
                boxShadow: "0px 4px 4px rgba(11, 7, 7, 0.25)",
                position: 'sticky',
                top: 0,
                zIndex: 999
            }}>
                <Toolbar disableGutters>
                    <Container maxWidth={'90%'} sx={{ width: { md: '90%', xs: '100%' }, m: 'auto' }}>
                        <Box
                            sx={{
                                flexGrow: 1,
                                // marginInlineStart: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'space-between',
                            }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <RouterLink
                                    to="/"
                                    style={{ textDecoration: "none", lineHeight: 1 }}>
                                    <img src={data?.headerLogo} alt="logo" className="nav-logo" />
                                </RouterLink>
                            </Box>
                            <Box sx={{
                                flexGrow: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'center',
                                gap: '5%'
                            }}>
                                {Pages?.map((page, i) => (
                                    <StyledLink
                                        key={i}
                                        to={page.path}
                                        className={'link text_bold'}
                                        onClick={() => scrollToTop()}
                                        style={({ isActive }) => ({
                                            color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
                                        })}
                                    >
                                        {lng === 'ar' ? page.name : page.name_en}
                                    </StyledLink>
                                ))}
                            </Box>
                            <TransLang />
                            <DarkModeToggle />
                        </Box>
                        <Box sx={{ justifyContent: 'space-between', display: 'flex', gap: { md: '65px', xs: 1 }, width: { md: 'fit-content', xs: '100%' }, alignItems: 'center' }} >
                            <Box
                                sx={{
                                    flexGrow: 0,
                                    display: { md: "none", xs: "flex" },
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: 'center'
                                }}>
                                <RouterLink
                                    to="/"
                                    style={{
                                        textDecoration: "none",
                                        lineHeight: 1
                                    }}>
                                    <img src={data?.headerLogo} alt="logo" className="nav-logo" ></img>
                                </RouterLink>
                                <IconButton onClick={() => setDrawer(true)}>
                                    <MenuIcon sx={{ fontSize: '2rem', color: theme.palette.secondary.main }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Container>
                </Toolbar>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} data={data} />
        </>
    );
}
export default Navbar2;
